import axios from "axios";
import { DefaultChannelListModel } from "../../datamodels/services/defaultChannelsModel";

export async function sendHomeDefaultChannelListApiCall(
  passedCommunityId: string
) {
  const response = await axios.post<DefaultChannelListModel>(
    `/community/landing/default/channels`,
    {
      communityId: passedCommunityId.toString(),
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
      },
    }
  );
  return response.data;
}
